export function formatPhone(phone) {
  var cleaned = phone.replace(/\D/g, '');
  var match = cleaned.match(/^([78])?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (!match) {
    return phone;
  }
  var intlCode = match[1] ? '7' : '7';
  return "+".concat(intlCode, " (").concat(match[2], ") ").concat(match[3], "-").concat(match[4], "-").concat(match[5]);
}